import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath('notes-ui!sofe')